import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function TenantLogin() {
    const { clientSlug } = useParams();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const user = await login(email, password, false);
            if (user.client_slug !== clientSlug && user.role !== 'admin') {
                toast.error("You don't have access to this tenant portal.");
                setLoading(false);
                return;
            }
            toast.success("Welcome back!");
            navigate(`/${clientSlug}`);
        } catch (err) {
            toast.error(err.response?.data?.detail || "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex bg-[#F4F7FB]">
             <div className="hidden lg:flex w-1/2 bg-[#0A192F] relative overflow-hidden flex-col justify-between p-12">
                 <div className="absolute inset-0 z-0 opacity-30" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1758518729841-308509f69a7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBjb3Jwb3JhdGUlMjBvZmZpY2V8ZW58MHx8fHwxNzkwNDg4NjI2fDA&ixlib=rb-4.1.0&q=85')", backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
                 <div className="absolute inset-0 bg-[#0A192F]/70 z-0 mix-blend-multiply"></div>
                 
                 <div className="z-10 flex items-center gap-3">
                     <img src="https://customer-assets-jai6qajn.emergentagent.net/job_financepro-57/artifacts/xfybzyti_Rc%20company%20png%20logo%20%281%29.jpg" alt="RC Company" className="w-16 h-16 rounded-xl object-contain shadow-lg border-2 border-white/10 bg-white" />
                     <div className="text-[#EAB308] font-bold text-3xl tracking-widest font-['Cabinet_Grotesk']">
                         R.C & COMPANY
                     </div>
                 </div>
                 
                 <div className="z-10 max-w-md">
                     <h2 className="text-4xl text-white font-bold mb-4 font-['Cabinet_Grotesk'] leading-tight">Financial Enterprise Precision.</h2>
                     <p className="text-slate-300 text-lg">Your dedicated portal for clear, high-velocity daily bookkeeping and ledger authority.</p>
                 </div>
             </div>
             
             <div className="w-full lg:w-1/2 flex items-center justify-center p-8">
                 <div className="max-w-md w-full">
                     <div className="mb-10 text-center lg:text-left">
                         <div className="inline-flex items-center justify-center px-4 py-1.5 rounded-full bg-slate-100 border border-slate-200 text-slate-700 text-sm font-semibold mb-6">
                            Tenant: <span className="text-[#0A192F] ml-1 font-mono">{clientSlug}</span>
                         </div>
                         <h1 className="text-3xl font-bold text-[#0A192F] font-['Cabinet_Grotesk']">Client Portal</h1>
                         <p className="text-slate-500 mt-2">Sign in to your bookkeeping workspace</p>
                     </div>
                     
                     <form onSubmit={handleSubmit} className="space-y-5">
                         <div>
                             <label className="block text-sm font-medium text-[#0F172A] mb-1.5">Email Address</label>
                             <input 
                                 type="email"
                                 data-testid="client-login-email-input"
                                 value={email}
                                 onChange={(e) => setEmail(e.target.value)}
                                 className="w-full h-12 px-4 rounded-xl border border-slate-300 bg-white text-slate-900 focus:outline-none focus:ring-2 focus:ring-[#0A192F] transition-shadow"
                                 placeholder="you@company.com"
                                 required
                             />
                         </div>
                         
                         <div>
                             <label className="block text-sm font-medium text-[#0F172A] mb-1.5">Password</label>
                             <input 
                                 type="password"
                                 data-testid="client-login-password-input"
                                 value={password}
                                 onChange={(e) => setPassword(e.target.value)}
                                 className="w-full h-12 px-4 rounded-xl border border-slate-300 bg-white text-slate-900 focus:outline-none focus:ring-2 focus:ring-[#0A192F] transition-shadow"
                                 placeholder="••••••••"
                                 required
                             />
                         </div>
                         
                         <button 
                             type="submit" 
                             data-testid="client-login-submit-button"
                             disabled={loading}
                             className="w-full h-12 mt-4 bg-[#0A192F] hover:bg-[#0F284E] text-white font-semibold rounded-xl shadow-md transition-all active:scale-[0.98] disabled:opacity-70 flex justify-center items-center"
                         >
                             {loading ? (
                                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                             ) : "Sign In to Workspace"}
                         </button>
                     </form>
                 </div>
             </div>
        </div>
    )
}
